import { render, staticRenderFns } from "./LinkExpired.vue?vue&type=template&id=0ea50bfa&scoped=true"
import script from "./LinkExpired.vue?vue&type=script&lang=js"
export * from "./LinkExpired.vue?vue&type=script&lang=js"
import style0 from "./LinkExpired.vue?vue&type=style&index=0&id=0ea50bfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea50bfa",
  null
  
)

export default component.exports